import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_COLLEGE_COUNSELLING_DESTINATION,
  DELETE_COLLEGE_COUNSELLING_DESTINATION,
  GET_COLLEGE_COUNSELLING_DESTINATIONS,
  UPDATE_COLLEGE_COUNSELLING_DESTINATION,
} from 'setup/redux/Actions/CollegeCounsellingDestination/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* collegeCounsellingDestinationSaga() {
  yield takeEvery(CREATE_COLLEGE_COUNSELLING_DESTINATION, fetchData)
  yield takeEvery(DELETE_COLLEGE_COUNSELLING_DESTINATION, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_DESTINATIONS, fetchData)
  yield takeEvery(UPDATE_COLLEGE_COUNSELLING_DESTINATION, fetchData)
}

export default collegeCounsellingDestinationSaga
